export default "__VITE_ASSET__DRvfyEQL__"